export interface ChallengeBucketArgument {
  id: string
  challengeID: string
  bucketId: string
  name: string
  goal: number
  sortOrder: number
  icon: string
  color?: string
}

export default class ChallengeBucket {
  readonly id: string
  readonly challengeID: string
  readonly bucketId: string
  readonly name: string
  readonly goal: number
  readonly sortOrder: number
  readonly icon: string
  readonly color?: string

  constructor(arg: ChallengeBucketArgument) {
    this.id = arg.id
    this.challengeID = arg.challengeID
    this.bucketId = arg.bucketId
    this.name = arg.name
    this.goal = arg.goal
    this.sortOrder = arg.sortOrder
    this.icon = arg.icon
    this.color = arg.color
  }

  static fromPG(row: any): ChallengeBucket {
    return new ChallengeBucket({
      id: row.id,
      challengeID: row.challenge_id,
      bucketId: row.bucket_id,
      name: row.name,
      goal: row.goal,
      sortOrder: row.sort_order,
      icon: row.icon,
      color: row.color ?? undefined,
    })
  }
}
